import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import BusinessIcon from '@mui/icons-material/Business';
import AddIcon from '@mui/icons-material/Add';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import './Company.css';

function CompanyIndex() {
  const { isAuthenticated, companyId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();
  const [data, setData] = useState([]);

  let companyid = companyId;
  if (isSuperAdmin === true && companyId === superCompanyId) companyid = 0;

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    fetchData('CompanyApi', '/' + companyid, token)
      .then((response) => {
        if (response.responseCode === '1111') setData(response.response_data);
      })
      .catch((error) => console.error('Error fetching Company Details:', error));
  }, [isAuthenticated, companyId, token]);

  return (
    <div className="company-container">
      <div className="company-header-card">
        <div className="company-header-content">
          <div className="company-title-section">
            <span className="company-title-icon"><BusinessIcon fontSize="small" /></span>
            <h1 className="company-title">Company</h1>
          </div>
          <div className="company-header-actions">
            {isSuperAdmin && companyId === superCompanyId && (
              <Link to="/companyCreate" className="co-btn co-btn-create">
                <AddIcon style={{ fontSize: 14 }} />&nbsp;Create New
              </Link>
            )}
          </div>
        </div>
      </div>

      <div className="company-table-wrapper">
        <TableContainer component={Paper} className="company-table-container" elevation={0}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell className="company-th">Sl.No</TableCell>
                <TableCell className="company-th">Name</TableCell>
                <TableCell className="company-th">Company Code</TableCell>
                <TableCell className="company-th">Contact 1</TableCell>
                <TableCell className="company-th">Contact 2</TableCell>
                <TableCell className="company-th">Email</TableCell>
                <TableCell className="company-th">GST Number</TableCell>
                <TableCell className="company-th" align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((item, index) => (
                <TableRow key={item.Id} className="company-row">
                  <TableCell className="company-td">{index + 1}</TableCell>
                  <TableCell className="company-td">{item.Name}</TableCell>
                  <TableCell className="company-td">{item.CompanyCode}</TableCell>
                  <TableCell className="company-td">{item.ContactNumber1}</TableCell>
                  <TableCell className="company-td">{item.ContactNumber2}</TableCell>
                  <TableCell className="company-td">{item.Email}</TableCell>
                  <TableCell className="company-td">{item.GSTNumber}</TableCell>
                  <TableCell className="company-td" align="center">
                    <div className="company-action-btns">
                      <Link to={'/companyEdit/' + item.ID}>
                        <IconButton className="company-icon-btn company-icon-edit" size="small" title="Edit">
                          <EditIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </Link>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default CompanyIndex;
